import React, { useCallback } from 'react';
import { StaffPriceEditProvider as MpStaffPriceEditProvider } from '../../../mp/components/Cart/StaffPriceEditContext';
import { usePreviewResetPriceOverrideMutation } from '../../../redux/rtk';

// Each mounted instance fires useGetPriceOverridesQuery; gate via `enabled`.
const ActivityStaffPriceEditProvider = ({
  enabled,
  children,
  jobId,
  asMember,
  requestForQuoteId,
}: {
  enabled: boolean;
  children: React.ReactNode;
  jobId: number | null;
  asMember: boolean;
  requestForQuoteId?: number;
}) => {
  const [previewResetMutation] = usePreviewResetPriceOverrideMutation();
  const previewResetQuote = useCallback(
    async (products: string[]) => {
      if (!jobId || products.length === 0) return null;
      try {
        const { quote } = await previewResetMutation({
          jobId,
          data: { products, requestForQuoteId },
        }).unwrap();
        return quote;
      } catch {
        return null;
      }
    },
    [jobId, requestForQuoteId, previewResetMutation]
  );

  if (!enabled) return <>{children}</>;
  // viewingVersionId=null → backend resolves to the job's current version.
  return (
    <MpStaffPriceEditProvider
      jobId={jobId}
      viewingVersionId={null}
      asMember={asMember}
      previewResetQuote={previewResetQuote}
    >
      {children}
    </MpStaffPriceEditProvider>
  );
};

export default ActivityStaffPriceEditProvider;
